const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/cash-accounts/api-factory');
const serviceFactory = require('../resources/cash-accounts/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/portfoliooverview/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';
  return app => app
    .match(`${p}cashAccounts.bookingList[{keys:bookingParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.cashAccountDetails(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match((`${p}cashAccounts.getRTCashAccList[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getRTCashAccList(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
}

module.exports = addRoutes;